// extracted by mini-css-extract-plugin
module.exports = {"wrap":"index_wrap_2Aq0J","label":"index_label_1KvNk"};